import type { SelectOption } from '@ur-solutions/react-components'
import { useMemo } from 'react'
import { countries } from '@/utils/countries'
import { languages } from './languages'
import type { AllowedLocale } from './util'

function getFlag(code: AllowedLocale): string {
  switch (code) {
    case 'nb':
      return countries.NO.emoji
    case 'en':
      return countries.GB.emoji
    case 'ru':
      return countries.RU.emoji
    case 'lv':
      return countries.LV.emoji
    case 'ro':
      return countries.RO.emoji
    case 'pl':
      return countries.PL.emoji
    case 'lt':
      return countries.LT.emoji
  }
}

export function useLanguageOptions() {
  const languageOptions = useMemo<SelectOption<AllowedLocale>[]>(
    () =>
      languages
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(lang => ({
          value: lang.code,
          label: `${getFlag(lang.code)} ${lang.name}`,
        })),
    []
  )

  return {
    languageOptions,
  }
}
